
import { Component, Vue } from 'vue-property-decorator'
import TicketSpyy from '@/views/Ticket/indexSpyy.vue'

@Component({
  name: 'AllOrderLists',
  components: {
    TicketSpyy
  }
})
export default class extends Vue {}
